import React, { Component, Fragment } from 'react';
import { cloneDeep } from 'lodash';

// Components
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MethodsListsBlocksList from '../../components/MethodsListsBlocksList';
import MethodsListsBlocksListHeader from '../../components/MethodsListsBlocksListHeader';
import TabSwitch from '../../components/TabSwitch';
import MethodDetailModal from '../../components/MethodDetailModal';
import Heading from '../../components/Heading';
import FiltersSidebar from '../../components/FiltersSidebar';

// Styles
import styles from './LandingPage.module.scss';

// Utils
import { MyContext } from '../../utils/myContext';
import * as parser from '../../utils/parser';


class LandingPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isTabSwitchTurnedOn: false,

            shouldShowMethodDetailModal: false,

            isFooterExpanded: false,
            isFiltersSidebarExpanded: false,

            methodsListsStartIndex: 0,
            methodsListsEndIndex: 4,

            searchFieldValue: "",
            searchFieldValueSuggestionsList: [],

            filtersSidebarSections: []
        };

        let hasContextAlreadyInitiallyFetchedData = false;

        let clickedMethod = undefined;
        console.log(clickedMethod, hasContextAlreadyInitiallyFetchedData);
    }

    componentDidMount = () => {
        if (this.context.state.hasInitiallyFetchedData) {
            this.hasContextAlreadyInitiallyFetchedData = true;
            this.parseFiltersSidebarSections();
        }
    }

    // This is necessary because the checkboxes value depends on the context

    componentDidUpdate = () => {
        if (this.context.state.hasInitiallyFetchedData !== this.hasContextAlreadyInitiallyFetchedData) {
            this.hasContextAlreadyInitiallyFetchedData = true;
            this.parseFiltersSidebarSections();
        }
    }

    parseFiltersSidebarSections = async () => {
        const filtersSidebarSections = await parser.parseFiltersSidebarSections(this.context.state.sortedMethods);
        this.setState({
            filtersSidebarSections
        })
    }

    render = () => {
        console.log("Landingpage is (re)rendering")
        return (
            <Fragment>
                <Header
                    searchFieldValue={this.context.state.headerSearchFieldValue}
                    onChangeSearchFieldValue={this.onChangeHeaderSearchFieldValue}
                    searchFieldValueSuggestionsLists={this.context.state.headerSearchFieldValueSuggestionsLists}
                    onClickSearchFieldValueSuggestion={this.onClickHeaderSearchFieldValueSuggestion}
                    onClickSearchFieldCloseIcon={this.onClickHeaderSearchFieldCloseIcon}
                    sortedSelectedMethodsCount={this.context.state.sortedSelectedMethodsCount}
                />
                <main>
                    {this.state.shouldShowMethodDetailModal &&
                        <div id={styles.methodDetailModalOuterContainer}>
                            <div id={styles.methodDetailModalInnerContainer}>
                                <MethodDetailModal
                                    heading={this.clickedMethod.fields["1_Name Technik DE"]}
                                    description={this.clickedMethod.fields["5_Beschreibung DE"]}
                                    roles={this.clickedMethod.fields["23_Rollen DE"]}
                                    principles={this.clickedMethod.fields["35_Prinzipien DE"]}
                                    measurementParameters={this.clickedMethod.fields["27_Messgrössen konsolidiert DE"]}
                                    benefits={this.clickedMethod.fields["15_Benefits konsolidiert DE"]}
                                    hasBeenSelected={this.clickedMethod.appendix.hasBeenSelected}
                                    onClickAdd={this.onClickAddMethod}
                                    onClickDelete={this.onClickDeleteMethod}
                                    onClickClose={this.onClickCloseMethodDetailModal}
                                />
                            </div>
                        </div>
                    }
                    <div id={styles.contentContainer}>
                        <div>
                            <Heading type="primary">
                                Agile Toolbox
                            </Heading>
                            <p>
                                Konfigurieren Sie Ihre eigenen agilen Methoden
                            </p>
                        </div>
                        <div>
                            <TabSwitch
                                isTurnedOn={this.state.isTabSwitchTurnedOn}
                                onChangeTabItem={this.onChangeTabItem}
                            />
                        </div>
                        <div>
                            <div id={styles.methodsListsBlocksListHeaderContainer}>
                                <MethodsListsBlocksListHeader
                                    methodsListsStartIndex={this.state.methodsListsStartIndex}
                                    methodsListsEndIndex={this.state.methodsListsEndIndex}
                                />
                            </div>
                            <div>
                                <MethodsListsBlocksList
                                    methodsListsBlocks={parser.filterSortedMethods(this.context.state.sortedMethods, this.state.filtersSidebarSections)}
                                    methodsListsStartIndex={this.state.methodsListsStartIndex}
                                    methodsListsEndIndex={this.state.methodsListsEndIndex}
                                    onClickMethod={this.onClickMethod}
                                    shouldSelectedMethodsBeHighlighted={true}
                                />
                            </div>
                        </div>
                    </div>
                    <FiltersSidebar
                        isExpanded={this.state.isFiltersSidebarExpanded}
                        filterSections={this.state.filtersSidebarSections}
                        onChangeCheckbox={this.onChangeFiltersSidebarCheckbox}
                        onClickInformationIcon={this.toggleMoreDetailsSidebarWidth}
                        onClickReturnButton={this.toggleMoreDetailsSidebarWidth}
                    />
                </main>
                <Footer
                    isExpanded={this.state.isFooterExpanded}
                    methodsLists={this.rearrangeSortedSelectedMethods(this.context.state.sortedSelectedMethods)}
                    methodsListsStartIndex={this.state.methodsListsStartIndex}
                    methodsListsEndIndex={this.state.methodsListsEndIndex}
                    onClickDeleteFooterMethod={this.onClickDeleteFooterMethod}
                    onClickArrowIcon={this.toggleFooterHeight}
                />
            </Fragment>
        )
    }

    onChangeHeaderSearchFieldValue = (e) => {
        const headerSearchFieldValue = e.target.value;
        this.context.setState({
            headerSearchFieldValue
        }, async () => {
            const headerSearchFieldValueSuggestionsLists = await parser.getHeaderSearchFieldValueSuggestionsLists(headerSearchFieldValue, this.context.state.sortedMethods);
            this.context.setState({
                headerSearchFieldValueSuggestionsLists
            })
        });
    };

    onClickHeaderSearchFieldValueSuggestion = (headerSearchFieldValueSuggestion) => {
        this.clickedMethod = headerSearchFieldValueSuggestion;

        this.setState({
            shouldShowMethodDetailModal: true
        })
    };

    onClickHeaderSearchFieldCloseIcon = () => this.context.setState({
        headerSearchFieldValue: ""
    });

    rearrangeSortedSelectedMethods = (sortedSelectedMethods) => {
        const rearrangedSortedSelectedMethods = [[], [], [], [], [], [], [], []];
        sortedSelectedMethods.forEach(footerMethodsListsBlock => {
            footerMethodsListsBlock.forEach((footerMethodsList, index) => {
                rearrangedSortedSelectedMethods[index].push(...footerMethodsList);
            })
        })
        return rearrangedSortedSelectedMethods;
    }

    onClickMethod = (method) => {
        this.clickedMethod = method;

        this.setState({
            shouldShowMethodDetailModal: true
        });
    }

    onClickDeleteFooterMethod = (footerMethod) => {
        const { collaborationLayerIndex, phaseDeepDiveIndex, methodIndex } = footerMethod.appendix;

        const deepClonedSortedMethods = cloneDeep(this.context.state.sortedMethods);
        const affectedMethod = deepClonedSortedMethods[collaborationLayerIndex][phaseDeepDiveIndex][methodIndex];
        affectedMethod.appendix.hasBeenSelected = false;

        let deepClonedSortedSelectedMethods = cloneDeep(this.context.state.sortedSelectedMethods);
        deepClonedSortedSelectedMethods[collaborationLayerIndex][phaseDeepDiveIndex] = deepClonedSortedSelectedMethods[collaborationLayerIndex][phaseDeepDiveIndex].filter(method => method.id !== footerMethod.id);

        this.context.setState({
            sortedMethods: deepClonedSortedMethods,
            sortedSelectedMethods: deepClonedSortedSelectedMethods,
            sortedSelectedMethodsCount: this.context.state.sortedSelectedMethodsCount - 1
        });
    }

    onChangeTabItem = () => {
        this.setState({
            isTabSwitchTurnedOn: !this.state.isTabSwitchTurnedOn,

            methodsListsStartIndex: !this.state.isTabSwitchTurnedOn ? 4 : 0,
            methodsListsEndIndex: !this.state.isTabSwitchTurnedOn ? 8 : 4
        });
    }

    onClickAddMethod = () => {
        const { clickedMethod } = this;
        const { collaborationLayerIndex, phaseDeepDiveIndex, methodIndex } = clickedMethod.appendix;

        const deepClonedSortedMethods = cloneDeep(this.context.state.sortedMethods);
        const affectedMethod = deepClonedSortedMethods[collaborationLayerIndex][phaseDeepDiveIndex][methodIndex];
        affectedMethod.appendix.hasBeenSelected = true;

        const deepClonedSortedSelectedMethods = cloneDeep(this.context.state.sortedSelectedMethods);
        deepClonedSortedSelectedMethods[collaborationLayerIndex][phaseDeepDiveIndex].push(affectedMethod);

        this.context.setState({
            sortedMethods: deepClonedSortedMethods,
            sortedSelectedMethods: deepClonedSortedSelectedMethods,
            sortedSelectedMethodsCount: this.context.state.sortedSelectedMethodsCount + 1
        });

        this.setState({
            shouldShowMethodDetailModal: false,
            isFooterExpanded: true
        });
    };

    onClickDeleteMethod = () => {
        const { clickedMethod } = this;
        const { collaborationLayerIndex, phaseDeepDiveIndex, methodIndex } = clickedMethod.appendix;

        const deepClonedSortedMethods = cloneDeep(this.context.state.sortedMethods);
        const affectedMethod = deepClonedSortedMethods[collaborationLayerIndex][phaseDeepDiveIndex][methodIndex];
        affectedMethod.appendix.hasBeenSelected = false;

        let deepClonedSortedSelectedMethods = cloneDeep(this.context.state.sortedSelectedMethods);
        deepClonedSortedSelectedMethods[collaborationLayerIndex][phaseDeepDiveIndex] = deepClonedSortedSelectedMethods[collaborationLayerIndex][phaseDeepDiveIndex].filter(method => method.id !== clickedMethod.id);

        this.context.setState({
            sortedMethods: deepClonedSortedMethods,
            sortedSelectedMethods: deepClonedSortedSelectedMethods,
            sortedSelectedMethodsCount: this.context.state.sortedSelectedMethodsCount - 1
        });

        this.setState({
            shouldShowMethodDetailModal: false,
            isFooterExpanded: true
        });
    };

    onClickCloseMethodDetailModal = () => this.setState({
        shouldShowMethodDetailModal: false
    });

    toggleFooterHeight = () => this.setState({
        isFooterExpanded: !this.state.isFooterExpanded
    })

    toggleMoreDetailsSidebarWidth = () => this.setState({
        isFiltersSidebarExpanded: !this.state.isFiltersSidebarExpanded
    })

    onChangeFiltersSidebarCheckbox = (name, value, isChecked) => {
        const { filtersSidebarSections } = this.state;
        const deepClonedFiltersSidebarSections = cloneDeep(filtersSidebarSections);
        deepClonedFiltersSidebarSections.find(filtersSidebarSection => filtersSidebarSection.name === name).checkboxes.find(checkbox => checkbox.value === value).isChecked = isChecked;

        this.setState({
            filtersSidebarSections: deepClonedFiltersSidebarSections
        })
    }
}

LandingPage.contextType = MyContext;

export default LandingPage;
